// Generated by ReScript, PLEASE EDIT WITH CARE


function machine(state, action) {
  if (typeof state !== "number" && state.TAG !== /* Data */0) {
    return state;
  }
  if (typeof action === "number") {
    return /* Init */0;
  } else if (action.TAG === /* FetchRestrictionBoundsSuccess */0) {
    return {
            TAG: /* Data */0,
            _0: action._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: action._0
          };
  }
}

export {
  machine ,
  
}
/* No side effect */
